module.exports = __webpack_public_path__ + "static/media/qrcode.67d0b72a.jpg";